/**
 * ============================================================================
 * EVOLIS — module assistant IA (développement Louis, conçu pour être détachable)
 *  Bouton « Evolis » compact affiché en bas de la sidebar, au-dessus du footer
 *  (ancre marquée EVOLIS dans Sidebar.js). Ouvre/ferme le dock flottant.
 *  Rendu uniquement si l'utilisateur a accès au module.
 * ============================================================================
 */

import React, { useState } from 'react';
import { accesEvolis } from './EvolisChat';
import EvolisLogo from './EvolisLogo';
import EvolisDock from './EvolisDock';
import './evolis.css';

const EvolisSidebarButton = () => {
    const [ouvert, setOuvert] = useState(false);

    if (!accesEvolis()) return null;

    return (
        <>
            <button
                className={`evolis-sidebar-btn${ouvert ? ' active' : ''}`}
                onClick={() => setOuvert((v) => !v)}
                title={ouvert ? 'Fermer le chat Evolis' : 'Discuter avec Evolis'}
            >
                <span className="evolis-sidebar-btn-avatar"><EvolisLogo size={13} /></span>
                <span className="evolis-sidebar-btn-nom">Evolis</span>
                <span className={`evolis-sidebar-btn-point${ouvert ? ' on' : ''}`} aria-hidden="true" />
            </button>

            {ouvert && <EvolisDock onFermer={() => setOuvert(false)} />}
        </>
    );
};

export default EvolisSidebarButton;
